<template>
<div :class="['content-box', { 'no-card': disableCard }]">
  <div class="m-2 pl-3 text-center" v-show="isLoading">
    <font-awesome-icon
      :icon="['fa', 'circle-notch']"
      class="fa-spin m-auto spinner fa-5x egx-partner-color"
    />
  </div>
  <div v-if="(offers?.length || 0) < 1" v-show="!isLoading">
    <p
      v-if="fulfill_sync_details.pages?.offers?.no_content"
      :class="fulfill_sync_details.pages.offers.no_content.class"
      :style="fulfill_sync_details.pages.offers.no_content.style"
      v-safe-html="fulfill_sync_details.pages.offers.no_content.text"
    />
  </div>
  <div :class="['card-body', { 'no-card': disableCard }]" v-for="(offer, index) in offers" v-else>
    <div class="row align-items-center mr-3">
      <div class="col-lg-10 d-flex align-items-center">
        <span class="egx-partner-color">
          <h4 class="mb-0">{{ offer.name }}</h4>
        </span>
      </div>
      <div class="col-lg-2">
        <button
          class="btn btn-egx d-flex justify-content-center align-items-center"
          style="height: 2rem; width: 10rem;"
          @click="Apply(offer.id)"
        >
          Apply
        </button>
      </div>
    </div>
    <div
      class="row mt-4"
    >
      <div class="col-12">
        <div>
          <div
            ref="descriptionRefs"
            :ref="el => descriptionRefs[index] = el"
            :style="expanded[index] || !shouldTruncate[index] ? {} : {
              overflow: 'hidden',
              display: '-webkit-box',
              '-webkit-line-clamp': '6',
              '-webkit-box-orient': 'vertical'
            }"
          >
            <div v-safe-html="offer.customer_description"></div>
          </div>

          <a
            v-if="shouldTruncate[index]"
            href="#"
            @click.prevent="toggleExpand(index)"
          >
            {{ expanded[index] ? 'see less' : 'see more' }}
          </a>
        </div>
      </div>
    </div>
    <hr v-if="index < offers.length - 1" />
  </div>
</div>
</template>

<script>

export default {
  components: {
  },

  props: {
    publicPage: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      offers: [],
      disableCard: false,
      isLoading: false,
      expanded: {},
      shouldTruncate: {},
      descriptionRefs: [],
    };
  },

  mounted() {
    this.checkTruncation();
  },

  updated() {
    this.checkTruncation();
  },

  created() {
    this.isLoading = true;

    let url = '';

    if (this.publicPage === true) {
      url = 'fulfill_integrate/get_programs_public_list';
    } else {
      url = 'fulfill_integrate/get_programs_list';
    }

    this.$store.dispatch(url, this.currentBuilding.selectedId).then(() => {
      let programs = this.$store.state.fulfill_integrate.programs;

      programs = programs.sort((a, b) => {
        const tagA = a.effective_sorting_tag || '';
        const tagB = b.effective_sorting_tag || '';
        return tagA.localeCompare(tagB);
      });

      this.offers = programs;
      this.$emit('number-of-programs', (this.offers?.length || 0));
    }).catch((error) => {
      this.$notify({
        group: 'notice-stay',
        type: 'error',
        text: error.message,
      });
    }).finally(() => {
      this.$emit('number-of-programs', (this.offers?.length || 0));
      this.isLoading = false;
      this.$nextTick(() => this.checkTruncation());
    });
  },

  methods: {
    Apply(offerId) {
      if (this.publicPage === true) {
        this.$router.push(`/user-registrations?program_id=${offerId}`);
      } else {
        this.$router.push(`/applications/new?programId=${offerId}`);
      }
    },

    toggleExpand(index) {
      this.$set(this.expanded, index, !this.expanded[index]);
    },
    checkTruncation() {
      this.$nextTick(() => {
        this.offers.forEach((offer, index) => {
          const el = this.descriptionRefs[index];
          if (el) {
            const maxLines = this.fulfill_sync_details.pages?.offers?.offer_card?.max_rows_number || 6;
            const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20;
            const maxHeight = lineHeight * maxLines;
            const isOverflowing = el.scrollHeight > maxHeight;

            this.$set(this.shouldTruncate, index, isOverflowing);
          }
        });
      });
    },
  },
  computed: {
    settings() {
      return this.$store.state.partners.currentPartner.settings;
    },
    currentBuilding() {
      return this.$store.state.buildings.currentBuilding;
    },
    fulfill_sync_details() {
      return this.settings.fulfill_sync_details;
    },
  }
}
</script>

<style scoped>
.card-body {
  margin-bottom: 10px;
}
hr {
  margin-bottom: -2rem;
  width: 60.8rem;
}
.egx-partner-color {
  color: inherit;
}
h4 {
  display: inline-block;
}
</style>
